import React from 'react';

export const Footer = () => (
  <footer>
    <div className="footer-logo reveal">ФОТОАРХИВ</div>
    <p className="footer-text reveal">Сохраняем историю, одну фотографию за раз</p>
    <div className="footer-line" />
    <div className="footer-copy reveal">© 2026 ФОТОАРХИВ — Все права защищены</div>
  </footer>
);